import Vue from 'vue';
import types from '../mutation-types';
import DashboardConversationsSummary from '../../api/inbox/dashboardConversationsSummary';

const state = {
  uiFlags: {
    isFetching: false,
    isError: false,
  },
  data: null,
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getData($state) {
    return $state.data;
  },
};

export const actions = {
  fetch: async ({ commit }) => {
    commit(types.SET_OPERATIONAL_DASHBOARD_UI_FLAG, {
      isFetching: true,
      isError: false,
    });
    try {
      const { data } = await DashboardConversationsSummary.getAll();
      commit(types.SET_OPERATIONAL_DASHBOARD_DATA, data);
      commit(types.SET_OPERATIONAL_DASHBOARD_UI_FLAG, {
        isFetching: false,
        isError: false,
      });
    } catch (error) {
      commit(types.SET_OPERATIONAL_DASHBOARD_UI_FLAG, {
        isFetching: false,
        isError: true,
      });
    }
  },
};

export const mutations = {
  [types.SET_OPERATIONAL_DASHBOARD_UI_FLAG]($state, uiFlags) {
    Vue.set($state, 'uiFlags', { ...$state.uiFlags, ...uiFlags });
  },
  [types.SET_OPERATIONAL_DASHBOARD_DATA]($state, data) {
    Vue.set($state, 'data', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
